import { Modal, ModalBody } from "react-bootstrap";

const ShowAlert = ({showModal, closeModal, title, icon, message})=>{
    return(
        <Modal show={showModal} className="custom-modal" centered>
            <Modal.Body>
            <div className="alert-container">
                <div className="alert-logo-container">
                    {icon && <div className="alert-icon">{icon}</div>}
                </div>
                <div className="alert-box">
                    <h2>{title}</h2>
                    <p>{message}</p>
                    <button type="submit" className="btn btn-primary btn-lg btn-xl generalBtn" onClick={closeModal}>Ok</button>
                </div>
            </div>
            </Modal.Body>
        </Modal>
    );
};
export default ShowAlert;